export const MODALS = {
    PAYIN_ORDER_CREATION: 'payin_order_creation',
    PAYIN_ORDER_APPEAL: 'payin_order_appeal',
    PAYIN_ORDER_CHECKS: 'payin_order_checks',
    PAYOUT_ORDER_REJECTION: 'payout_order_rejection',
    PAYOUT_ORDER_CONFIRMATION: 'payout_order_confirmation',
    PAYOUT_ORDER_SPLIT: 'payout_order_split',
} as const;
